/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEditExcel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12.414 2H2v20h8v-2H4V4h7v5h5v1h2V7.586zm2.172 5H13V5.414z" />
        <path d="m5 11 1.674-2.592L5.083 6H6.42l1.122 1.726L8.632 6h1.285l-1.6 2.427L10 11H8.662l-1.21-1.891L6.286 11zm12.293 1.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414L16.414 22H12v-4.414zM14 18.414V20h1.586l4-4L18 14.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgEditExcel as EditExcel };
